import React, { useState, useEffect } from 'react'
import GoogleMapReact from 'google-map-react'
import * as jsts from 'jsts'
import MapSearchBox from '../MapSearchBox'
import { mapShading } from '../../Shared/constants'
import CreateNewErrorModal from '../../../UI/CreateNewErrorModal'
import {
  ClearGeoButton,
  ButtonContainer,
  MapContainer,
  MapWrapper,
  SearchContainer
} from './styles'

const { REACT_APP_GOOGLE_API_KEY } = process.env

const CreateNewSiteMap = props => {
  const [mapsApiLoaded, setMapsApiLoaded] = useState(false)
  const [mapsapi, setMapsApi] = useState()
  const [mapInstance, setMapInstance] = useState()
  const [polygon, setPolygon] = useState()
  const [showShapeError, setShowShapeError] = useState(false)
  const [drawingManager, setDrawingManager] = useState()
  const [radius, setRadius] = useState()

  const errorToggle = () => {
    setShowShapeError(!showShapeError)
  }

  const defaultCenter = {
    center: {
      lat: 49.266405,
      lng: -123.104049
    },
    zoom: 11
  }
  const [centerMap, setCenterMap] = useState({
    lat: 49.266405,
    lng: -123.104049
  })
  const [zoomMap, setZoomMap] = useState(11)
  const [markerPosition, setMarkerPosition] = useState({
    lat: 49.266405,
    lng: -123.104049
  })

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos => {
        const coords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        }
        setCenterMap(coords)
      })
    } else {
      // alert('Sorry, you need to enable location services in your browser')
    }
  }

  //Function that checks to see if the shape intersects
  const checkForValidShape = () => {
    if (!polygon) return false
    const polygonBounds = polygon.getPath()
    const coordinates = getShapeCoords(polygonBounds)
    const jstsCoordinates = polygonCoords2JTS(coordinates)
    const geometryFactory = new jsts.geom.GeometryFactory()
    const linearRing = geometryFactory.createLinearRing(jstsCoordinates)
    const jstsPolygon = geometryFactory.createPolygon(linearRing)
    const validator = new jsts.operation.IsSimpleOp(jstsPolygon)
    return validator.isSimpleLinearGeometry(jstsPolygon)
  }

  //Function takes array of coordinates and converst to jsts array of coordinates
  const polygonCoords2JTS = polygonCoords => {
    const jstsCoordinates = polygonCoords.map(pt => {
      return new jsts.geom.Coordinate(pt.lat, pt.lng)
    })
    jstsCoordinates.push(new jsts.geom.Coordinate(polygonCoords[0].lat, polygonCoords[0].lng))
    return jstsCoordinates
  }

  const getShapeCoords = polygonBounds => {
    return polygonBounds.getArray().map(point => {
      return {
        lat: point.lat(),
        lng: point.lng()
      }
    })
  }

  const setShapeCenter = siteCoordinates => {
    const coordinates = polygonCoords2JTS(siteCoordinates)
    const geometryFactory = new jsts.geom.GeometryFactory()
    const linearRing = geometryFactory.createLinearRing(coordinates)
    const { x, y } = linearRing.getCentroid()._coordinates._coordinates[0]
    const latLngCenter = {
      lat: x,
      lng: y
    }
    setMarkerPosition(latLngCenter)
    return latLngCenter
  }

  const getFarthestPointFromCenter = (siteCoordinates, shapeCenter) => {
    return siteCoordinates.reduce((acc, currentVal) => {
      return Math.max(
        acc,
        distance(shapeCenter.lat, shapeCenter.lng, currentVal.lat, currentVal.lng)
      )
    }, 0)
  }

  const distance = (lat1, lon1, lat2, lon2) => {
    var R = 6371
    var dLat = (lat2 - lat1) * (Math.PI / 180)
    var dLon = (lon2 - lon1) * (Math.PI / 180)
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = (R * c).toFixed(2)
    return d
  }

  const onShapeComplete = (polygonCoords, drawingManager, maps) => {
    drawingManager.setDrawingMode(null)
    drawingManager.setMap(null)
    if (polygon) {
      polygon.setMap(null)
    }
    const polygonBounds = polygonCoords.getPath()
    const siteCoordinates = getShapeCoords(polygonBounds)
    const shapeCenter = setShapeCenter(siteCoordinates)
    const polyRadius = getFarthestPointFromCenter(siteCoordinates, shapeCenter, maps)
    setRadius(polyRadius)
    setPolygon(polygonCoords)
  }

  const apiLoaded = (map, maps) => {
    if (!map || !maps) {
      alert('Unknown error has occured. Please try again')
      window.location.reload()
    }
    setMapInstance(map)
    setMapsApi(maps)
    setMapsApiLoaded(true)
    const shapeOptions = {
      ...mapShading,
      draggable: true,
      editable: true
    }
    const drawingManager = new maps.drawing.DrawingManager({
      drawingControl: true,
      drawingControlOptions: {
        position: maps.ControlPosition.LEFT_BOTTOM,
        drawingModes: ['polygon']
      },
      polygonOptions: shapeOptions
    })
    setDrawingManager(drawingManager)
    drawingManager.setMap(map)

    maps.event.addListener(drawingManager, 'overlaycomplete', ({ type, overlay }) => {
      if (type === 'polygon') {
        onShapeComplete(overlay, drawingManager, maps)
        maps.event.addListener(overlay, 'dragend', () => {
          onShapeComplete(overlay, drawingManager, maps)
        })
        maps.event.addListener(overlay.getPath(), 'insert_at', () => {
          onShapeComplete(overlay, drawingManager, maps)
        })
        maps.event.addListener(overlay.getPath(), 'set_at', () => {
          onShapeComplete(overlay, drawingManager, maps)
        })
      }
    })

    if (props.editSiteDetail) {
      if (props.editSiteDetail.customCoordinates) {
        const initialPolygon = new maps.Polygon({
          paths: props.editSiteDetail.customCoordinates,
          ...shapeOptions
        })
        setPolygon(initialPolygon)
        maps.event.addListener(initialPolygon.getPath(), 'dragend', () => {
          onShapeComplete(initialPolygon, drawingManager, maps)
        })
        maps.event.addListener(initialPolygon.getPath(), 'insert_at', () => {
          onShapeComplete(initialPolygon, drawingManager, maps)
        })
        maps.event.addListener(initialPolygon.getPath(), 'set_at', () => {
          onShapeComplete(initialPolygon, drawingManager, maps)
        })
      }
    }
  }

  const submitNewSiteMap = () => {
    const isValid = checkForValidShape()
    setShowShapeError(!isValid)
    if (isValid) {
      const polygonBounds = polygon.getPath()
      const siteCoordinates = getShapeCoords(polygonBounds)
      props.locationCoordinatesEntry(siteCoordinates, markerPosition, radius)
    }
  }

  const redrawSite = () => {
    if (polygon) {
      setPolygon(null)
      polygon.setMap(null)
    }
    drawingManager.setMap(mapInstance)
  }

  const handleSiteError = () => {
    errorToggle()
    redrawSite()
  }

  const onPlacesChanged = place => {
    const center = {
      lat: place[0].geometry.location.lat(),
      lng: place[0].geometry.location.lng()
    }

    setCenterMap(center)
    setMarkerPosition(center)
    setZoomMap(11)
  }

  useEffect(() => {
    if (polygon) {
      submitNewSiteMap()
    }
  }, [polygon])

  useEffect(() => {
    getLocation()
  }, [])

  return (
    <MapWrapper>
      <MapContainer>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: REACT_APP_GOOGLE_API_KEY,
            libraries: ['places', 'drawing']
          }}
          defaultCenter={defaultCenter.center}
          defaultZoom={defaultCenter.zoom}
          center={centerMap}
          zoom={zoomMap}
          draggable={true}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => apiLoaded(map, maps)}
          options={{
            streetViewControl: false,
            scaleControl: true,
            fullscreenControl: false,
            mapTypeControl: true,
            mapTypeControlOptions: {
              mapTypeIds: ['roadmap', 'satellite', 'hybrid']
            },
            zoomControl: true,
            clickableIcons: false
          }}
        ></GoogleMapReact>
        <SearchContainer>
          {mapsApiLoaded && mapsapi.places && (
            <MapSearchBox onPlacesChanged={onPlacesChanged} map={mapInstance} mapsapi={mapsapi} />
          )}
        </SearchContainer>
      </MapContainer>
      <ButtonContainer>
        {polygon ? (
          <div>
            <ClearGeoButton onClick={redrawSite}>Clear Geo-Fence</ClearGeoButton>
          </div>
        ) : null}
      </ButtonContainer>
      {showShapeError && (
        <CreateNewErrorModal
          title={polygon ? 'Invalid Geofence Shape' : 'Missing Geo-fence'}
          message={
            polygon
              ? 'Redraw the geogence to contain a single area'
              : 'Draw a geo-fence before saving'
          }
          handleOk={handleSiteError}
        />
      )}
    </MapWrapper>
  )
}

export default CreateNewSiteMap
